import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full border-b transition-all duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1280px] items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-xl" />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">韩国漫画</span>
            <span className="text-[11px] text-foreground-500">高分榜单 · 专题合集</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href="#top"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              <i className={`${link.icon} text-base`} />
              {link.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <label className="flex h-10 w-56 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3.5 transition-colors focus-within:border-primary-400 lg:w-64">
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              type="text"
              placeholder="搜索作品、作者或题材"
              name="q"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </label>
          <a
            href="#rank-entry"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            浏览榜单
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-800 lg:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <label className="mb-3 flex h-10 items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3.5">
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              type="text"
              placeholder="搜索作品、作者或题材"
              name="q"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
            />
          </label>
          <div className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href="#top"
                onClick={() => setMenuOpen(false)}
                className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm font-medium text-foreground-800"
              >
                <i className={`${link.icon} text-base text-primary-500`} />
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}